<template>
  <div class="dialog-wrap">
    <el-dialog title="物流信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="620px">
      <div class="progress"
           v-if="expressInfo">
        <div class="label">快递公司：</div>
        <div class="value">{{expressInfo.express_name }}</div>
      </div>
      <div class="progress"
           v-if="expressInfo">
        <div class="label">快递单号：</div>
        <div class="vaule">{{expressInfo.express_no }}</div>
      </div>

      <div class="progress"
           v-if="expressInfo">
        <div class="label">快递进度：</div>
        <div class="value">
          <p class="tips"
             v-if="!expressInfo">暂无数据</p>
          <div class="info-list"
               v-else>
            <div class="info-item"
                 v-for="(item, index) of expressInfo.list"
                 :key="index">
              <div class="top">
                <span class="status">{{item.status}}</span>
                <span class="time">{{item.time}}</span>
              </div>
              <div class="content">
                <span>{{item.context}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminUrl } from '../../../utils/helper'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,

      expressInfo: null,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        /*         if (!val.express_no) {
                  this.editStatus = true
                } else {
                  this.editStatus = false
                } */
        if (val.express_code && val.express_no) {
          this.fetchExpressInfo()
        }
      }
    },
  },
  methods: {
    // 快递进度查询
    async fetchExpressInfo() {
      let str = adminUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/back/crm/warrant/order/expressInfo`,
        method: 'get',
        params: { order_id: this.content.id },
      })
      this.expressInfo = res.data
    },

    handleClose() {
      this.$emit('close')
      this.expressInfo = null
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
  }

  .progress {
    display: flex;

    .label {
      width: 100px;
      text-align: right;
      padding-right: 12px;
    }
    .value {
      flex: 1;
    }

    .info-item {
      & + .info-item {
        margin-top: 10px;
      }
    }

    .status {
      font-size: 13px;
      font-weight: bold;
      margin-right: 5px;
    }
    .time {
      font-size: 12px;
    }
    .content {
      line-height: 1.5;
      font-size: 13px;
      color: #999999;
      margin-top: 5px;
    }
    .tips {
      font-size: 13px;
      color: #999999;
    }
  }
}
</style>
